// ABOUTME: Shared triage helpers for the /software feedback UI (status/severity labels + reference id).
// ABOUTME: TriageStatus mirrors the backend enum (enum.utils.js); keep values in sync.

// Mirror of warehouse-api app/utils/enum.utils.js TriageStatus (numeric).
export const TriageStatus = {
    New: 0,
    Analyzing: 1,
    Analyzed: 2,
    Approved: 3,
    Rejected: 4,
};

// i18n key per triage status. Falls back to a generic label key when unknown.
export const triageStatusKey = (status) => {
    switch (status) {
        case TriageStatus.New: return "feedback_triage_status_new";
        case TriageStatus.Analyzing: return "feedback_triage_status_analyzing";
        case TriageStatus.Analyzed: return "feedback_triage_status_analyzed";
        case TriageStatus.Approved: return "feedback_triage_status_approved";
        case TriageStatus.Rejected: return "feedback_triage_status_rejected";
        default: return "feedback_triage_status_new";
    }
};

// ShLabel color variant per triage status.
export const triageStatusVariant = (status) => {
    switch (status) {
        case TriageStatus.New: return "grey";
        case TriageStatus.Analyzing: return "yellow";
        case TriageStatus.Analyzed: return "blue";
        case TriageStatus.Approved: return "green";
        case TriageStatus.Rejected: return "red";
        default: return "grey";
    }
};

// Mirror of warehouse-api app/utils/enum.utils.js WorkOrderStatus (numeric).
export const WorkOrderStatus = {
    Approved: 0,
    PlanProposed: 1,
    PlanAccepted: 2,
    Executed: 3,
    MergeApproved: 4,
    Done: 5,
    Halted: 6,
    Rejected: 7,
};

// Mirror of warehouse-api app/utils/enum.utils.js QualityGateStatus (numeric).
export const QualityGateStatus = {
    NotRun: 0,
    Passed: 1,
    Failed: 2,
};

// i18n key per work-order status. Falls back to the approved label when unknown.
export const workOrderStatusKey = (status) => {
    switch (status) {
        case WorkOrderStatus.Approved: return "wo_status_approved";
        case WorkOrderStatus.PlanProposed: return "wo_status_plan_proposed";
        case WorkOrderStatus.PlanAccepted: return "wo_status_plan_accepted";
        case WorkOrderStatus.Executed: return "wo_status_executed";
        case WorkOrderStatus.MergeApproved: return "wo_status_merge_approved";
        case WorkOrderStatus.Done: return "wo_status_done";
        case WorkOrderStatus.Halted: return "wo_status_halted";
        case WorkOrderStatus.Rejected: return "wo_status_rejected";
        default: return "wo_status_approved";
    }
};

// ShLabel color variant per work-order status.
export const workOrderStatusVariant = (status) => {
    switch (status) {
        case WorkOrderStatus.Approved: return "grey";
        case WorkOrderStatus.PlanProposed: return "yellow";
        case WorkOrderStatus.PlanAccepted: return "blue";
        case WorkOrderStatus.Executed: return "purple";
        case WorkOrderStatus.MergeApproved: return "green";
        case WorkOrderStatus.Done: return "green";
        case WorkOrderStatus.Halted: return "orange";
        case WorkOrderStatus.Rejected: return "red";
        default: return "grey";
    }
};

// ShLabel color variant per severity (P0 worst → P3 mildest).
export const severityVariant = (severity) => {
    switch (severity) {
        case "P0": return "red";
        case "P1": return "orange";
        case "P2": return "yellow";
        case "P3": return "grey";
        default: return "grey";
    }
};

// Reference id mirrors the backend reference.js: "#FB-" + first 8 chars, uppercased.
export const toReferenceId = (id) => (id ? "#FB-" + String(id).slice(0, 8).toUpperCase() : "");
